<script setup>
defineProps({
  wrapperClass: {
    type: String,
    default: ''
  }
});
const isLoading = defineModel({ type: Boolean, default: true })
</script>

<template>
  <Transition name="fade">
    <div v-if="isLoading" :class="[wrapperClass, `absolute w-full h-full backdrop-blur-[4px] z-[30] bg-white/40 text-blue-500 p-[10%] -m-2`]">
      <div class="sticky top-1/2 -translate-y-[50%] flex justify-center items-center">
        <Spinner class="size-8" />
      </div>
    </div>
  </Transition>
</template>
